import React, { useEffect, useState } from 'react';
import { Switch, Route, withRouter } from "react-router-dom";
import Shake from '@shakebugs/browser';
import LandingPage from './pages/LandingPage';
import LogIn from './pages/LogIn';
import SignUp from './pages/SignUp';
import TestPageV2 from './pages/TestPageV2';
import AboutUs from './pages/AboutUs';
import AlertsPage from './pages/AlertsPage';
import BeforeTest from './pages/BeforeTest';
import Contraindications from './pages/Contraindications';
import Intermediary from './pages/Intermediary';
import TestSelection from './pages/TestSelection';
import PositiveResult from './pages/PositiveResult';
import NegativeResult from './pages/NegativeResult';
import HomePage from './pages/HomePage';
import CardioOnly from './pages/CardioOnly';
import CardioResult from './pages/CardioResult';
import CardioPOC from './pages/CardioPOC';
import ThanksPage from './pages/Thanks';
import Navigation from './pages/Navigation';
import Info from './pages/Info';
import Verify from './pages/Verify';
import UpdateProfile from './pages/UpdateProfile';
import TestHistory from './pages/TestHistory';
import QRIpage from './pages/QRIpage';
import ErrorPage from './pages/ErrorPage';
import ForgotPassword from './pages/ForgotPassword';
import TermsAndConditionOldUser from './pages/TermsAndConditionOldUser';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import UnProtectedRoute from './components/UnProtectedRoute';
import ProtectedRouteCovid from './components/ProtectedRouteCovid';
import ProtectedRouteCardio from './components/ProtectedRouteCardio';
import ProtectedRouteCardioPOC from './components/ProtectedRouteCardioPOC';
import Settings from './pages/Settings';
import PrivacySettings from './pages/PrivacySettings';
import UploadTestFiles from './pages/UploadTestFiles';
import config from './config';
import Alert from './pages/Alert';
import UnknownCrash from './pages/UnknownCrash';
import Footer from './components/Footer';
import Billing from './pages/Billing';
import Pay from './pages/Pay';
import Plans from './pages/Plans';
import Payments from './pages/Payments';
import PayInvoice from './pages/PayInvoice';
import QRCodeScanPageV2 from './pages/QRCodeScanPageV2';
import CovidTestResultV2 from './pages/CovidTestResultV2';
import ResultV2 from './pages/ResultV2';
import ProductPage from './pages/ProductPage';
import {ToastContainer} from "react-toastify";
import HomePageMobile from './pages/HomePageMobile';

const injectCustomStyles = () => {
  const shadowHost = document.querySelector('#shake-sdk-main-button-root');
  
  if (shadowHost && shadowHost.shadowRoot) {
    const shadowRoot = shadowHost.shadowRoot;
    const style = document.createElement('style');
    
    style.textContent = `
      @media (max-width: 768px) {
        .shake-sdk-main-button {
          right: 0px !important;
          height: 40px !important;
          min-width: 40px !important;
        }

        .shake-sdk-main-button p {
          display: none;
        }
      }
    `;

    shadowRoot.appendChild(style);
  }
};

function App(props) {
  Shake.start(config.shakebugs.apiKey, config.shakebugs.appDomain);

  useEffect(() => {
    injectCustomStyles();
  }, []);

  const [signUp, setSignup] = useState(false);
  const [isAuth] = useState(false);

  return (
    <React.Fragment>
      <div className="app">
        <ScrollToTop/>
        <Switch>
          <UnProtectedRoute exact path='/' {...props} comp={LandingPage}/>
          <UnProtectedRoute path="/login" comp={() => <LogIn signUp={signUp} setSignup={setSignup}/>}/>
          <UnProtectedRoute path="/signup" comp={() => <SignUp setSignup={setSignup}/>}/>
          <ProtectedRoute path='/home' {...props} comp={HomePage}/>
          <ProtectedRoute path='/home-mobile' {...props} comp={HomePageMobile}/>
          <ProtectedRoute path="/settings" comp={Settings}/>
          <ProtectedRoute path="/privacy-settings" comp={PrivacySettings}/>
          <ProtectedRoute path="/testSelection" comp={TestSelection}/>
          <ProtectedRoute path="/aboutus" comp={AboutUs}/>
          <ProtectedRoute path="/positiveresult" comp={PositiveResult}/>
          <ProtectedRoute path="/negativeresult" comp={NegativeResult}/>
          <ProtectedRoute path='/navigation' comp={Navigation}/>
          <ProtectedRoute path='/info' comp={Info}/>
          <ProtectedRoute path='/alerts/:alertId' comp={Alert}/>
          <ProtectedRoute path='/alerts' comp={AlertsPage}/>
          <ProtectedRoute path='/update-profile' comp={UpdateProfile}/>
          <ProtectedRoute path='/testhistory' comp={TestHistory}/>
          <ProtectedRoute path='/covid/testresult' comp={CovidTestResultV2}/>
          <ProtectedRoute path="/account" component={Billing}/>
          <ProtectedRoute path="/plans" component={Plans}/>
          <ProtectedRoute path="/invoice/:invoiceId" component={PayInvoice}/>
          <ProtectedRoute path="/payments" component={Payments}/>
          <ProtectedRoute path="/pay" component={Pay}/>
          <ProtectedRouteCovid path="/qri" comp={QRIpage}/>
          <ProtectedRouteCovid path="/contraindications" comp={Contraindications}/>
          <ProtectedRouteCovid path="/beforetest" comp={BeforeTest}/>
          <ProtectedRouteCovid path="/intermediary" comp={Intermediary}/>
          <ProtectedRouteCovid path="/testWithCamera" comp={TestPageV2}/>
          <ProtectedRouteCovid path="/testWithUpload" comp={UploadTestFiles}/>
          <ProtectedRouteCovid path="/result" comp={ResultV2}/>
          <ProtectedRouteCardio path="/cardio" comp={CardioOnly}/>
          <ProtectedRouteCardio path='/cardio-result' comp={CardioResult}/>
          <ProtectedRouteCardioPOC path="/cardio-poc" comp={CardioPOC}/>
          <ProtectedRouteCardioPOC path="/thanks" component={ThanksPage}/>
          <Route path="/verify/:uid/:token" component={() => <Verify isAuth={isAuth}/>}/>
          <Route path="/verify" component={() => <Verify initLanding={true} isAuth={isAuth}/>}/>
          <Route path="/forgot-password" component={ForgotPassword}/>
          <Route path='/update-tnc' component={TermsAndConditionOldUser}/>
          <Route path="/reset-password/:uid/:token"
                 component={(props) => <ForgotPassword {...props} isCreateNewPassword/>}/>
          <Route path='/covid/:uid' component={QRCodeScanPageV2}/>
          <Route path="/products" component={ProductPage}/>
          <Route path="/error" component={UnknownCrash}/>
          <Route path='*' component={ErrorPage}/>
        </Switch>
        <div className="react-toast">
          <ToastContainer
            position="top-right"
            autoClose={8000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
        </div>
        <Footer/>
      </div>
    </React.Fragment>
  );
}

export default withRouter(App);
